import React from 'react';
import './TabDocuments.css';
import CreateForm from '../../../Design/Forms/CreateForm';



function TabHome() {
  return (
    <>
    <div className="container">
        <div className="title title-1">Upcoming Investments</div>
        <div className="title title-2">Investment Round Deadline</div>
        <div className="item item-3">< CreateForm /></div>
        <div className="item item-4">


        </div>

    </div>
    </>
  )
}

export default TabHome

